import { Ear, Footprints } from "lucide-react";

/**
 * Display metadata only. Whether a practice is usable is the server's answer (GET /clinical/practices, shown by
 * clinical/PracticeSwitcher), never a flag in the browser.
 */
export const practices = {
  audiology: { name: "Audiology", Icon: Ear },
  podiatry: { name: "Podiatry", Icon: Footprints },
} as const;
export type PracticeId = keyof typeof practices;
export type FieldView =
  "day" | "today" | "manifest" | "schedule" | "devices" | "inventory" | "followups" | "atd-all" | "twl";
export const isFieldView = (value: string | null): value is FieldView =>
  value !== null &&
  [
    "day",
    "today",
    "manifest",
    "schedule",
    "devices",
    "inventory",
    "followups",
    "atd-all",
    "twl",
  ].includes(value);
